import styled from 'styled-components';

export const ContentWithFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
`;
